import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.HintConfiguration';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class HintConfiguration extends RpcClass{

    /**
     *  @class HintConfiguration
     *  @alias module:src/server/com/silkplm/rpc/plm/HintConfiguration.HintConfiguration
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param formClass {string} 
     * @param fieldName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/HintInput.HintInput>}
     */
     getHintInput(formClass, fieldName) {
            return RpcClass.rpcCall('/rpc/plm/hint-configuration/get-hint-input', [formClass, fieldName]);
    }
    /** 
     * @async
     * @param formClass {string} 
     * @param fieldName {string} 
     * @param hintMessage {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/HintInput.HintInput>}
     */
     saveHint(formClass, fieldName, hintMessage) {
            return RpcClass.rpcCall('/rpc/plm/hint-configuration/save-hint', [formClass, fieldName, hintMessage]);
    }
    /** 
     * @async
     * @param formClass {string} 
     * @param fieldName {string} 
     * @param hintMessage {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/HintInput.HintInput>}
     */
     updateHint(formClass, fieldName, hintMessage) {
            return RpcClass.rpcCall('/rpc/plm/hint-configuration/update-hint', [formClass, fieldName, hintMessage]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.HintConfiguration';
metadata.__type_short__ = 'HintConfiguration';
HintConfiguration.prototype.__metadata__ = metadata;

HintConfiguration.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/HintConfiguration */
export default HintConfiguration

export { HintConfiguration }
